import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, mergeProps as _mergeProps, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "fav__car-top" }
const _hoisted_2 = { class: "h5 fav__car-name" }
const _hoisted_3 = { class: "fz-smaller fav__car-model" }
const _hoisted_4 = { class: "fav__car-overlay" }
const _hoisted_5 = {
  key: 0,
  class: "swiper-container slider__gallery fav__car-slider"
}
const _hoisted_6 = { class: "swiper-wrapper" }
const _hoisted_7 = { class: "swiper-slide dflex" }
const _hoisted_8 = ["data-src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "swiper-lazy-preloader" }, null, -1)
const _hoisted_10 = ["href", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon add-favorite__icon",
  width: "16",
  height: "14"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#heart-fill" })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "mark__text" }
const _hoisted_14 = { class: "fav__car-bottom" }
const _hoisted_15 = {
  key: 0,
  class: "fav__car-price"
}
const _hoisted_16 = { class: "price" }
const _hoisted_17 = { class: "h4" }
const _hoisted_18 = { class: "price__bottom" }
const _hoisted_19 = { class: "price__bottom-text" }
const _hoisted_20 = {
  key: 1,
  class: "price price__discount"
}
const _hoisted_21 = { class: "h4" }
const _hoisted_22 = { class: "price__mark" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  class: "price__mark-bg",
  src: "/img/red-mark.png",
  alt: ""
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "price__mark--minus" }, "-", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "price__mark--percent" }, "%", -1)
const _hoisted_26 = {
  key: 2,
  class: "price__bottom"
}
const _hoisted_27 = { class: "price__bottom-text" }
const _hoisted_28 = { class: "fav__car-features" }
const _hoisted_29 = { class: "features__list" }
const _hoisted_30 = {
  key: 0,
  class: "features__list-label tooltip__info"
}
const _hoisted_31 = { class: "features__list-text" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "KM", -1)
const _hoisted_33 = { class: "fav__car-stock" }
const _hoisted_34 = { class: "fav__car-top" }
const _hoisted_35 = { class: "h5 fav__car-name" }
const _hoisted_36 = { class: "fz-smaller fav__car-model" }
const _hoisted_37 = { class: "fav__car-comparison tooltip__info" }
const _hoisted_38 = { class: "checkbox" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "sprite-icon comparison__icon",
    width: "20",
    height: "20"
  }, [
    /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#compare" })
  ])
], -1)
const _hoisted_40 = { class: "fav__car-overlay" }
const _hoisted_41 = ["href", "onClick"]
const _hoisted_42 = { class: "mark__text" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon add-favorite__icon",
  width: "16",
  height: "14"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#heart-fill" })
], -1)
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["src"]
const _hoisted_46 = { class: "fav__car-bottom" }
const _hoisted_47 = {
  key: 0,
  class: "fav__car-price"
}
const _hoisted_48 = { class: "price" }
const _hoisted_49 = { class: "h4" }
const _hoisted_50 = { class: "price__bottom" }
const _hoisted_51 = { class: "price__bottom-text" }
const _hoisted_52 = {
  key: 0,
  class: "price price__discount"
}
const _hoisted_53 = { class: "h4" }
const _hoisted_54 = { class: "price__mark" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("img", {
  class: "price__mark-bg",
  src: "/img/red-mark.png",
  alt: ""
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "price__mark--minus" }, "-", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "price__mark--percent" }, "%", -1)
const _hoisted_58 = {
  key: 1,
  class: "price__bottom"
}
const _hoisted_59 = { class: "price__bottom-text" }
const _hoisted_60 = { class: "fav__car-features" }
const _hoisted_61 = { class: "features__list" }
const _hoisted_62 = {
  key: 0,
  class: "features__list-label tooltip__info"
}
const _hoisted_63 = { class: "features__list-text" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("b", null, "KM", -1)
const _hoisted_65 = { class: "fav__car-stock" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_app_format_currency = _resolveComponent("app-format-currency")!
  const _component_app_vehicle_options = _resolveComponent("app-vehicle-options")!
  const _directive_app_gallery = _resolveDirective("app-gallery")!
  const _directive_app_auth_required = _resolveDirective("app-auth-required")!
  const _directive_tippy = _resolveDirective("tippy")!

  return (_ctx.isApproved)
    ? (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 0,
        class: "fav__car"
      }, _ctx.$attrs), [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.vehicleTileDto.brand?.name + " " + _ctx.vehicleTileDto.model), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.vehicleTileDto.motorisation) + " " + _toDisplayString(_ctx.vehicleTileDto.finish), 1)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["fav__car-picture", { 'arrow-hover': _ctx.arrowHover }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.vehicleTileDto.thumbnail_image)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("img", {
                        class: "swiper-lazy",
                        "data-src": _ctx.vehicleTileDto.thumbnail_image.href_small,
                        style: {
                                    objectFit: 'cover',
                                    'background-color': '#f4f8fd',
                                }
                      }, null, 8, _hoisted_8),
                      _hoisted_9
                    ])
                  ])
                ])), [
                  [_directive_app_gallery]
                ])
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: {
                        path: `/auth/vehicle-details/${_ctx.vehicleTileDto.id}`,
                        query: {
                            ..._ctx.filters,
                        },
                    },
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  class: "button button--outline",
                  onClick: _withModifiers(() => _ctx.routeToCarDetails(navigate, true), ["prevent"])
                }, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.viewDetails" })
                ], 8, _hoisted_10)), [
                  [_directive_app_auth_required, {
                            role: 'dealer',
                            showLogin: !_ctx.isAuthenticated,
                            disable: true,
                        }]
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_ctx.isApproved)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["add-favorite", { active: _ctx.vehicleTileDto.is_favorite }]),
                type: "button",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)))
              }, _hoisted_12, 2))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionDtos, (promotion) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "fav__car-mark",
              key: promotion
            }, [
              _createElementVNode("div", {
                class: "mark__icon",
                style: _normalizeStyle({
                        backgroundImage: `url(/img/our-cars/${_ctx.iconNameForPromotion(
                            promotion,
                        )}.svg)`,
                    })
              }, null, 4),
              _createElementVNode("span", _hoisted_13, _toDisplayString(promotion?.name), 1)
            ]))
          }), 128))
        ], 2),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.vehicleTileDto.pricing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                (_ctx.vehicleTileDto.pricing?.discount_euro <= 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, [
                          _createVNode(_component_app_format_currency, {
                            value: _ctx.vehicleTileDto.pricing.list_price_euro,
                            currency: _ctx.currency
                          }, null, 8, ["value", "currency"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                        ])
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                (_ctx.vehicleTileDto.pricing?.discount_euro > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("p", _hoisted_21, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.vehicleTileDto.pricing.price_after_discount_euro,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _hoisted_24,
                        _createElementVNode("span", null, _toDisplayString(_ctx.vehicleTileDto.pricing.discount_percentage), 1),
                        _hoisted_25
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.vehicleTileDto.pricing.discount_euro > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fz-smaller price__bottom-num", {
                            'line-through': _ctx.vehicleTileDto.pricing.list_price_euro,
                        }])
                      }, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.vehicleTileDto.pricing.list_price_euro,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ], 2),
                      _createElementVNode("span", _hoisted_27, [
                        _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              (_ctx.vehicleTileDto.mileage)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _createElementVNode("p", _hoisted_31, [
                      _createTextVNode(_toDisplayString(_ctx.vehicleTileDto.mileage) + " ", 1),
                      _hoisted_32
                    ])
                  ])), [
                    [_directive_tippy, {
                                content: _ctx.i18n.t('carCard.kmUsed'),
                                interactive: true,
                            }]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_app_vehicle_options, {
                "vehicle-id": _ctx.vehicleTileDto.id,
                "show-label": false,
                size: 6
              }, null, 8, ["vehicle-id"])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _withDirectives(_createElementVNode("div", {
              class: _normalizeClass(["stock__color purple tooltip__info", [`--${_ctx.vehicleTileDto.color?.name}`]]),
              style: _normalizeStyle({
                        backgroundColor: _ctx.vehicleTileDto.color?.hex,
                        color: _ctx.vehicleTileDto.color?.is_light ? 'black' : 'white',
                    })
            }, null, 6), [
              [_directive_tippy, {
                        content: _ctx.vehicleTileDto.color?.name,
                        interactive: true,
                    }]
            ])
          ])
        ])
      ], 16))
    : (_openBlock(), _createElementBlock("div", _mergeProps({
        key: 1,
        class: "fav__car not-login"
      }, _ctx.$attrs), [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.vehicleTileDto.brand?.name + " " + _ctx.vehicleTileDto.model), 1),
          _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.vehicleTileDto.motorisation) + " " + _toDisplayString(_ctx.vehicleTileDto.finish), 1),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isSelectedForComparison) = $event))
                }, null, 512), [
                  [_vModelCheckbox, _ctx.isSelectedForComparison]
                ]),
                _hoisted_39
              ])
            ])
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["fav__car-picture", { 'arrow-hover': _ctx.arrowHover }])
        }, [
          _createElementVNode("div", _hoisted_40, [
            _createVNode(_component_router_link, {
              to: {
                        path: `/auth/vehicle-details/${_ctx.vehicleTileDto.id}`,
                        query: {
                            ..._ctx.filters,
                        },
                    },
              custom: ""
            }, {
              default: _withCtx(({ href, navigate }) => [
                _withDirectives((_openBlock(), _createElementBlock("a", {
                  href: href,
                  class: "button button--outline",
                  onClick: _withModifiers(() => _ctx.routeToCarDetails(navigate, true), ["prevent"])
                }, [
                  _createVNode(_component_i18n_t, { keypath: "carCard.viewDetails" })
                ], 8, _hoisted_41)), [
                  [_directive_app_auth_required, {
                            role: 'dealer',
                            showLogin: !_ctx.isAuthenticated,
                            disable: true,
                        }]
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionDtos, (promotion) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "fav__car-mark",
              key: promotion
            }, [
              _createElementVNode("div", {
                class: "mark__icon",
                style: _normalizeStyle({
                        backgroundImage: `url(/img/our-cars/${_ctx.iconNameForPromotion(
                            promotion,
                        )}.svg)`,
                    })
              }, null, 4),
              _createElementVNode("span", _hoisted_42, _toDisplayString(promotion?.name), 1)
            ]))
          }), 128)),
          (_ctx.isApproved)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["add-favorite", { active: _ctx.vehicleTileDto.is_favorite }]),
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleFavorite && _ctx.toggleFavorite(...args)))
              }, _hoisted_44, 2))
            : _createCommentVNode("", true),
          (_ctx.vehicleTileDto.thumbnail_image)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                class: "fav__car__image",
                src: _ctx.vehicleTileDto.thumbnail_image.href_small,
                style: { 'background-color': '#f4f8fd' }
              }, null, 8, _hoisted_45))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_46, [
          (_ctx.vehicleTileDto.pricing)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                _createElementVNode("template", null, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("p", _hoisted_49, [
                      _createVNode(_component_app_format_currency, {
                        value: _ctx.vehicleTileDto.pricing.list_price_euro,
                        currency: _ctx.currency
                      }, null, 8, ["value", "currency"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("span", _hoisted_51, [
                      _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                    ])
                  ])
                ]),
                (_ctx.vehicleTileDto.pricing.discount_euro > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                      _createElementVNode("p", _hoisted_53, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.vehicleTileDto.pricing.discount_euro,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _hoisted_55,
                        _hoisted_56,
                        _createElementVNode("span", null, _toDisplayString(_ctx.vehicleTileDto.pricing.discount_percentage), 1),
                        _hoisted_57
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.vehicleTileDto.pricing.discount_euro > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["fz-smaller price__bottom-num", {
                            'line-through': _ctx.vehicleTileDto.pricing.list_price_euro,
                        }])
                      }, [
                        _createVNode(_component_app_format_currency, {
                          value: _ctx.vehicleTileDto.pricing.price_after_discount_euro,
                          currency: _ctx.currency
                        }, null, 8, ["value", "currency"])
                      ], 2),
                      _createElementVNode("span", _hoisted_59, [
                        _createVNode(_component_i18n_t, { keypath: "carCard.excludeVAT" })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              (_ctx.vehicleTileDto.mileage)
                ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_62, [
                    _createElementVNode("p", _hoisted_63, [
                      _createTextVNode(_toDisplayString(_ctx.vehicleTileDto.mileage) + " ", 1),
                      _hoisted_64
                    ])
                  ])), [
                    [_directive_tippy, {
                                content: _ctx.i18n.t('carCard.kmUsed'),
                                interactive: true,
                            }]
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_app_vehicle_options, {
                "vehicle-id": _ctx.vehicleTileDto.id,
                "show-label": false,
                size: 6
              }, null, 8, ["vehicle-id"])
            ])
          ]),
          _createElementVNode("div", _hoisted_65, [
            _withDirectives((_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["stock__color purple tooltip__info", [`--${_ctx.vehicleTileDto.color?.name}`]]),
              style: _normalizeStyle({
                        backgroundColor: _ctx.vehicleTileDto.color?.hex,
                        color: _ctx.vehicleTileDto.color?.is_light ? 'black' : 'white',
                    })
            }, [
              _createTextVNode(_toDisplayString(1))
            ], 6)), [
              [_directive_tippy, {
                        content: _ctx.vehicleTileDto.color?.name,
                        interactive: true,
                    }]
            ])
          ])
        ])
      ], 16))
}